:host {
  display: block;
  width: 100%;
  @include cms-base-font-100;
  margin: 0 auto var(--cms-components-mb);
}

:host(:not([is-alternate])) {
  border-bottom: 1px solid var(--cms-semanticColors-base-weak-border);
}

.work-step-container {
  --cms-grid-padding: var(--cms-spacing-200) var(--cms-spacing-100);
  @include cms-default-grid-container;
}

.work-step-container>* {
  grid-area: var(--cms-default-grid-area);
}

.headline-wrapper {
  --cms-grid-padding: 0;
  margin-top: 0;
  margin-bottom: var(--cms-spacing-100);
  @include headline-font-150;
  display: flex;
  align-items: baseline;
}

.step-count {
  font-family: var(--cms-brandfont2);
  width: var(--cms-spacing-200);
  min-width: var(--cms-spacing-200);
  height: var(--cms-spacing-200);
  border-radius: var(--cms-border-radius-half);
  background-color: var(--cms-semanticColors-primary-background);
  color: var(--cms-semanticColors-primary-textOnBackground);
  font-weight: var(--cms-base-font-weight-700);
  font-size: var(--cms-font-size-125);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: var(--cms-spacing-100);
}

.text-content-wrapper {
  margin-bottom: var(--cms-spacing-075);
}

.text-container {
  color: var(--cms-semanticColors-base-strong-text);
}

.step-text {
  --cms-text-color: var(--cms-semanticColors-base-strong-text);
  display: inline;
}

.step-text p:nth-child(1) {
  display: inline;
  margin: 0;
}

.step-text p {
  margin-top: var(--cms-spacing-075);
  margin-bottom: 0;
}

.image-wrapper {
  height: fit-content;
  position: relative;
  border: none;
  padding: 0;
  margin: 0;
}

.step-text a {
  color: var(--cms-theme-text-color);
  text-decoration: underline;
}

.modal-icon {
  display: none;
  position: absolute;
  right: var(--cms-spacing-150);
  top: var(--cms-spacing-100);
}

@include media-width($breakpoint-sm) {

  .work-step-container.left,
  .work-step-container.right {
    grid-auto-flow: column;
  }

  .text-container.only-content,
  .image-wrapper.only-content {
    --cms-default-grid-area: auto / auto / auto / span 12;
  }

  .image-wrapper {
    --cms-default-grid-area: auto / auto / auto / span 4;
  }

  .text-container {
    --cms-default-grid-area: auto / 3 / auto / span 4;
  }

  .work-step-container.left .image-wrapper {
    --cms-default-grid-area: auto / 3 / auto / span 4;
  }

  .work-step-container.left .text-container {
    --cms-default-grid-area: auto / auto / auto / span 4;
  }

  .modal-icon {
    display: block;
  }

  .image-wrapper {
    cursor: pointer;
  }

  .text-content-wrapper {
    margin-bottom: 0;
  }
}

@include media-width($breakpoint-md) {
  .work-step-container {
    --cms-grid-gap: var(--cms-spacing-200);
  }

  .text-container.only-content,
  .image-wrapper.only-content {
    --cms-default-grid-area: auto / 3 / auto / span 8;
  }

}